export default {
  'registerBenefit.member_recruitment': 'Member Recruitment',
  'registerBenefit.apply': 'Apply for Membership',
  'registerBenefit.follow_friend_tip': 'Become a brand friend to receive benefit notifications.',
} as Record<string, string>;
